import taskManagerApi from "@/features/shared/services/taskManagerApi";
import { ObjectUtil } from "@/features/shared/utils/ObjectUtil";
export async function fetchTimeOffRequests(page = 1, filters = {}, limit = 10, sort = "-start_at") {
    try {
        const params = {
            ...(page ? { page } : {}),
            ...(filters || {}),
            ...(limit ? { limit } : {}),
            ...(sort ? { sort } : {}),
        };
        const response = await taskManagerApi.get("/absences", { params });
        const { absences, meta } = response.data.data;
        return {
            timeOffRequests: absences,
            meta,
        };
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        throw new Error("Erreur inconnue lors de la récupération des demandes d'absence");
    }
}
export async function createTimeOffRequest(request) {
    try {
        const response = await taskManagerApi.post("/absences", request);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        throw new Error("Erreur inconnue lors de la création de la demande d'absence");
    }
}
export async function updateTimeOffRequest(request) {
    try {
        const payload = ObjectUtil.omitField(request, "id");
        const response = await taskManagerApi.put(`/absences/${request.id}`, payload);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        throw new Error("Erreur inconnue lors de la mise à jour de la demande d'absence");
    }
}
export async function deleteTimeOffRequest(id) {
    try {
        const response = await taskManagerApi.delete(`/absences/${id}`);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        throw new Error("Erreur inconnue lors de la suppression de la demande d'absence");
    }
}
export async function fetchTimeOffHistory(id) {
    if (!id) {
        return [];
    }
    try {
        const response = await taskManagerApi.get(`/absences/${id}/history`);
        return response.data?.data ?? [];
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        throw new Error("Erreur inconnue lors de la récupération de l'historique");
    }
}
